




















import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Images extends Vue {
    public static getRndInteger(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min)) + min;
    }
    private r: number = Images.getRndInteger(0, 3);
}
